import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BreadcrumbComponent} from '../breadcrumb/breadcrumb.component';
import {PagesEnum} from '../../model/pages.enum';
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-header',
  imports: [
    BreadcrumbComponent,
    I18NextPipe
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HeaderComponent{


  @Input() title: string;
  @Input() subtitle: string;
  @Input() page: PagesEnum;

  protected readonly PagesEnum = PagesEnum;

}
